<template lang="pug">
div.wrap-module-post
  div(v-if="avatar").wrap-post-content
    div.wrap-post.pt14.mb14
      div.f.flex-between
        div.wrap-icon.mr8
          div.wrap-img.f.fh
            img(:src="avatar.iconURL")
        div.wrap-textarea
          textarea.pt5(
            v-if="user",
            :placeholder="`${user.name}さんは、いま何してる？`",
            v-model="postValue",
            ref="textarea")
      div.f.flex-right
        div(v-if="selectedImg").wrap-selected-img.f.fh.mb12
          div(@click="onCancelImg").close-icon
            v-icon cancel
          img(ref="selectedImg" :src="selectedImg")
    div.wrap-menu.pb20
      div.wrap-img-menu.pb16
        div.wrap-thumbnail.f.fm
          ItemImgUploader(
            :imgId="imgId",
            ref="mediaUploader",
            @afterUpload="afterUpload").mr4
          div(@click="onEmotion(item)" v-for="item in avatar.emotions").emotion.f.fh.mr4
            img(:src="item")
      div.wrap-tags.f.flex-wrap
        span(v-for="item in avatar.tags" @click="onTag(item)").tag.mr6.mb2 {{`#${item}`}}
</template>

<style lang="scss" scoped>
.wrap-module-post {
  .wrap-post-content {
    .wrap-post {
      width: 92%;
      margin: 0 auto;
      max-width: 620px;
      border-bottom: solid rgba(0, 0, 0, 0.2) 1px;
      .wrap-icon {
        width: 10%;
        .wrap-img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: solid 1px rgba(0, 0, 0, 0.2);
          overflow: hidden;
          img {
            object-fit: cover;
          }
        }
      }
      .wrap-textarea {
        width: 90%;
        textarea {
          width: 100%;
          height: 240px;
          outline: none;
          resize: none;
          font-size: 16px;
          // transform: scale(0.8);
        }
      }
      .wrap-selected-img {
        position: relative;
        object-fit: cover;
        max-width: 90%;
        .close-icon {
          position: absolute;
          top: 8px;
          right: 8px;
        }
        img {
          width: 100%;
          border-radius: 3px;
        }
      }
    }
    .wrap-menu {
      .wrap-img-menu {
        margin-left: 4%;
        .wrap-thumbnail {
          overflow-x: scroll;
          -webkit-overflow-scrolling: touch;
          .emotion {
            overflow: hidden;
            border: solid 0.6px rgba(0, 0, 0, 0.2);
            border-radius: 9px;
            width: 80px;
            min-width: 80px;
            height: 110px;
            img {
              object-fit: cover;
            }
          }
        }
      }
      .wrap-tags {
        width: 92%;
        margin: 0 auto;
        max-width: 620px;
        .tag {
          color: #ff9999;
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
const { mapState: mapStatePost, mapActions: mapActionsPost } = createNamespacedHelpers('post')
import ItemImgUploader from '@/components/item/ItemImgUploader'

export default {
  components: {
    ItemImgUploader
  },
  computed: {
    ...mapStateAuth([
      'uid',
      'isAnonymous'
    ]),
    ...mapStatePost([
      'tweetToRetweet'
    ]),
    imgId: () => {
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var autoId = ''
      for (let i = 0; i < 20; i++) {
        autoId += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return autoId
    }
  },
  props: {

  },
  data () {
    return {
      avatar: null,
      postValue: '',
      user: null,
      selectedImg: null,
      selectedImgURL: null
    }
  },
  async mounted () {
    if (this.tweetToRetweet) this.postValue += `\n\n${this.tweetToRetweet}`

    this.avatar = await db.collection('avatars')
      .doc(this.$route.params.id)
      .get()
      .then((d) => {
        var avatar = d.data()
        avatar.id = d.id
        return avatar
      })
    
    if (!this.uid || this.isAnonymous) {
      var message = `${this.avatar.name}になるとi（私）としてツイートできます！${this.avatar.typeName}${this.avatar.num + 1}号になってくれませんか？`
      var toSignIn = confirm(message)
      var to = (toSignIn) ? `/sign-up/${this.$route.params.id}` : `/avatar/${this.$route.params.id}`
      this.$router.push(to)
    }

    if (this.uid) {
      this.user = await db.collection('users')
        .doc(this.uid)
        .get()
        .then(d => {
          return d.data()
        })
    }

    this.$nextTick(() => {
      if (this.$refs.textarea) this.$refs.textarea.focus()
    })
  },
  methods: {
    afterUpload (data) {
      this.selectedImgURL = data.imgUrl
      this.$emit('setImgURL', data.base64)
      this.selectedImg = data.base64
    },
    onEmotion (emotionPath) {
      console.log("onEmotion:", emotionPath)
      this.$emit('setImgURL', `${location.origin}${emotionPath}`)
      this.selectedImg = `${location.origin}${emotionPath}` // emotionPath
      this.selectedImgURL = emotionPath
      setTimeout((self) => {
        this.selectedImg = self.imageToBase64(self.$refs.selectedImg, 'image/png')
      }, 400, this)
    },
    onCancelImg () {
      this.selectedImg = null
    },
    imageToBase64(img, mime_type) {
      // New Canvas
      var canvas = document.createElement('canvas')
      canvas.width  = img.naturalWidth
      canvas.height = img.naturalHeight
      // Draw Image
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      // To Base64
      return canvas.toDataURL(mime_type)
    },
    onTag (tag) {
      this.postValue += ` #${tag} `
      this.$refs.textarea.focus()
    }
  }
}
</script>
